<template>
  <div id="case-detail">
    <header-section :subnav_show="false" :change_color="true"></header-section>
    <!-- ======= Hero Section ======= -->
    <div id="hero-case" data-aos="zoom-out" data-aos-delay="100"></div>

    <div class="container" data-aos="fade-up">
        <div class="col-lg-12 entries">
            <div class="case_top">
                <div class="blue_yab" style="width:150px;text-align: left; text-indent: 1.5em;">
                    <div class="blue_name">项目概要</div>
                    <div class="blue_jt"></div>
                </div>
                <div class="show_img"><img :src="this.articleDetail.image" alt=""></div>
                <div class="case_summary">
                    <h3>{{this.articleDetail.title}}</h3>
                    <div v-html="this.articleDetail.summary" class="case_content"></div>
                </div>
            </div>
            <div class="case_detail">
                <div class="case_info">
                    <div class="blue_yab" style="width:150px; text-align: left; text-indent: 1.5em;">
                        <div class="blue_name">项目详情</div>
                        <div class="blue_jt"></div>
                    </div>
                    <div class="case_content case_content_pay">
                      <div v-html="this.articleDetail.content"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- footer -->
    <footer-section></footer-section>
  </div>
</template>
<script>
import HeaderSection from "@/components/public/head.vue"
import FooterSection from "@/components/public/footer.vue"
export default {
  components: {
    HeaderSection,
    FooterSection
  },
  props: {},
    data() {
      return {
        articleId: 0,
        articleDetail: {},
      };
    },
    watch: {
    },
    computed: {
    },
    methods: {
      getArticleDetail(){
        this.$get(this.$api.getArticleDetail+"/"+this.articleId).then(response=>{
          if(response.code===0){
            this.articleDetail = response.data;
            this.setBrowserTitle(response.data.title)
            this.addMetaKeyWords(response.data.title)
            this.loading = false
          }else{
            window.console.log(response.msg);
          }
        });
      },
      //动态修改浏览器标题
      setBrowserTitle(title) {
        document.title = title;
        },
        //动态添加meta标签 keywords content
        addMetaKeyWords (keywords) {
            let m = document.querySelectorAll('meta');
            for(let i=0;i<m.length;i++){
                if(m[i].content ==keywords){
                    m[i].remove()
                }
            }
            const meta = document.createElement('meta')
            meta.name = 'keywords'
            meta.content = keywords
            document.head.appendChild(meta)
            
        },
    },
    created() {
      this.articleId = this.$route.params.id;
      if(this.$isEmpty(this.articleId)){
            return this.$message.error('请检查信息是否存在');
      }
      this.getArticleDetail();
    },
    mounted() {
    },
    destroyed(){
        document.title='河北科瑞达仪器科技股份有限公司-官方网站'
    }
};
</script>
<style scoped>
/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/
#hero-case {
    width: 100%;
    height: 45vh;
    background: url("~@/static/img/banner/customer-banner.jpg");
    background-size: cover;
    position: relative;
}
#case-detail{
    overflow-x: hidden;
}
/*--------------------------------------------------------------
# cases detail
--------------------------------------------------------------*/
.case_top {
    position: relative;
    box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
    padding: 30px 30px 30px 0px;
    border-radius: 5px;
    background: #fff;
    transition: 0.5s;
    margin: 40px auto 30px;
    min-height: 300px;
}
/*.case_top {*/
/*    margin: 40px auto 30px;*/
/*}*/
.case_summary{
    padding: 30px;
    background: #fff;
}
.case_summary h3{
    font-size: 18px;
    font-weight: 700;
}

.case_info {
    position: relative;
    box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
    padding-top: 30px;
    padding-left: 0px;
    border-radius: 5px;
    background: #fff;
    transition: 0.5s;
}
.case_detail {
    padding: 19px 0px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-bottom: 35px;
}
.show_img {
    display: block;
    float: left;
    padding: 30px;
}
.show_img img{
    width: 320px;
    height: 200px;
    float: left;
}
.right_info {
    width: 4.56rem;
    float: left;
    margin-left: 0.19rem;
    text-align: left;
}
.case_lable {
    height: 40px;
    background: #eaebef;
    border-radius: 0.03rem;
    text-align: center;
    display: table;
    padding: 0 0.2rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 80px;
}
.case_name {
    font-size: 18px;
    font-weight: 400;
    color: #333;
    line-height: 20px;
    margin: 14px 0;
}
.case_sminfo {
    width: 4.56rem;
    min-height: 85px;
    font-size: 16px;
    font-weight: 400;
    color: #9c9c9c;
    line-height: 32px;
    margin-bottom: 25px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
}
.smname {
    text-align: left;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    font-size: 14px;
    font-weight: 400;
    line-height: .2rem;
}
.clear {
    clear: both;
}
.case_bottom {
    margin-bottom: 40px;
    padding-top: 50px;
}
.blue_yab {
    height: 46px;
    background-size: 100%;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    line-height: 46px;
    text-align: left;
    text-indent: 1.5em;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.blue_yab>.blue_name {
    height: 46px;
    background: #004baa;
    padding-right: 15px;
}
.blue_yab .blue_jt {
    border: 23px solid transparent;
    border-left-color: #004baa;
    width: 0;
    height: 0;
    position: relative;
    left: -1px;
}
.case_content {
    font-size: 16px;
    text-align: left;
    line-height: 150%;
    padding: 30px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
</style>